export default "__VITE_ASSET__CAIX4Apx__"